<template>
  <div class="permission-grid">
    <b-form-checkbox
      v-for="def in definitions"
      :key="def.key"
      :checked="isChecked(def.key)"
      :disabled="isDisabled(def.key)"
      class="mb-1"
      @change="(checked) => toggle(def.key, checked)"
    >
      <span class="fw-medium">{{ def.label }}</span>
      <span class="d-block small text-muted">{{ def.description }}</span>
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: "PermissionCheckboxes",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    definitions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasAll() {
      return this.value.includes("ALL");
    },
  },
  methods: {
    isChecked(key) {
      return this.value.includes(key);
    },
    isDisabled(key) {
      if (key === "ALL") return false;
      return this.hasAll;
    },
    toggle(key, checked) {
      let next = [...this.value];

      if (key === "ALL") {
        next = checked ? ["ALL"] : [];
      } else if (checked) {
        next = next.filter((p) => p !== "ALL");
        if (!next.includes(key)) next.push(key);
      } else {
        next = next.filter((p) => p !== key);
      }

      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.permission-grid {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
</style>
